<template>
  <!-- Vue Router reuses a page when only its params change; the page key remounts it on a
       new record or account instead, so pages need no id watchers. Any wrapper that renders
       child pages (an app-shell branch such as administration) must render them through this. -->
  <router-view v-slot="{ Component, route }">
    <component :is="Component" :key="getPageKey(route)" />
  </router-view>
</template>

<script setup lang="ts">
import { getPageKey } from '@/bundles/App/helpers/pageKey';
</script>
